// Amounts may arrive as decimal strings. Shown as `$1,234.50`; no currency code until the backend defines one.
// numberWithCommas drops trailing zeros on decimals ('1234.50' -> '1,234.5'), so it cannot give two decimals here.
// eslint-disable-next-line import/prefer-default-export
export function formatBeachClubMoney(value) {
  const amount = Number(value)
  if (value === null || value === undefined || value === '' || Number.isNaN(amount)) return '—'
  return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}
